export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_08.20c6fb8d.jpg";